import { useUser } from "@features/user-account/queries"
import { Card, Group, Stack, Table, Text } from "@mantine/core"
import { IconShieldLock, IconUser, IconWifi } from "@tabler/icons-react"
import GetEduroamLogo from "@assets/geteduroam_logo.svg"

export const WiFiStep: React.FC = () => {

    const { data: user } = useUser()

    return (
        <Stack gap="xl" w={600}>
            <Text>
                Our whole campus is covered by <Text span fw={700}>Eduroam</Text> - a free WiFi network available at thousands of academic and research locations around the world. Feel free to connect as many devices as you like.
            </Text>
            <Stack gap="md">
                <Text>
                    If you have an <Text span fw={700}>iPhone, iPad, or laptop</Text>, you can connect using these details:
                </Text>
                <Group justify="center">
                    <Card p={0} withBorder w={450}>
                        <Table variant="vertical" layout="fixed">
                            <Table.Tbody>
                                <Table.Tr>
                                    <Table.Th w={200}><Group align="center"><IconWifi size={20} /> Network Name</Group></Table.Th>
                                    <Table.Td>eduroam</Table.Td>
                                </Table.Tr>

                                <Table.Tr>
                                    <Table.Th><Group align="center"><IconUser size={20} /> Username</Group></Table.Th>
                                    <Table.Td>{user?.userPrincipalName}</Table.Td>
                                </Table.Tr>

                                <Table.Tr>
                                    <Table.Th><Group align="center"><IconShieldLock size={20} /> Password</Group></Table.Th>
                                    <Table.Td>Your College password</Table.Td>
                                </Table.Tr>
                            </Table.Tbody>
                        </Table>
                    </Card>
                </Group>
            </Stack>
            <Stack gap="md" mt="xl">
                <Text>
                    If you have an <Text span fw={700}>Android phone or tablet</Text> (e.g. Samsung Galaxy or Google Pixel), you'll need to use the getEduroam app from the Google Play Store to connect:
                </Text>
                <Group justify="center">
                    <Card withBorder w="fit-content">
                        <Group>
                            <img src={GetEduroamLogo} alt="getEduroam Logo" style={{ width: 50, borderRadius: 8 }} />
                            <Text size="lg" fw={700}>
                                getEduroam
                            </Text>
                        </Group>
                    </Card>
                </Group>
            </Stack>
        </Stack>
    )
}